import { render } from "./feature-products.vue?vue&type=template&id=3093133c"
import script from "./feature-products.vue?vue&type=script&lang=js"
export * from "./feature-products.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__